document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 1024) return;

  const highlightGrids = document.querySelectorAll('.highlight-grid');

  if (!highlightGrids.length) return;

  const items = document.querySelectorAll('[data-highlight-grid-item]');
  const button = document.querySelector('[data-highlight-items-toggle]');
  const buttonLabel = button.querySelector('.label');
  const buttonIcon = button.querySelector('.icon');
  const buttonShowMoreTranslation = button.getAttribute('data-show-more-translation');
  const buttonShowLessTranslation = button.getAttribute('data-show-less-translation');

  function updateButtonText() {
    const hiddenItems = Array.from(items).filter((item, index) => index >= 3 && item.classList.contains('hidden'));
    buttonLabel.textContent = hiddenItems.length > 0 ? buttonShowMoreTranslation : buttonShowLessTranslation;
    buttonIcon.classList.toggle('flipped', hiddenItems.length === 0);
  }

  function toggleGridItems() {
    items.forEach((item, index) => {
      if (index >= 3) {
        item.classList.toggle('hidden');
      }
    });
    updateButtonText();
  }

  function handleResize() {
    if (window.innerWidth >= 1024) {
      items.forEach(item => item.classList.remove('hidden'));
      button.classList.add('hidden');
    } else {
      button.classList.remove('hidden');
      items.forEach((item, index) => {
        if (index >= 3) {
          item.classList.add('hidden');
        }
      });
      updateButtonText();
    }
  }

  window.addEventListener('resize', handleResize);

  items.forEach((item, index) => {
    if (index >= 3) {
      item.classList.add('hidden');
    }
  });

  updateButtonText();

  button.addEventListener('click', toggleGridItems);
});
